import React, { useEffect, useRef, useState, useMemo } from 'react';
import { AcceptButton, BottomCaption, CancelButton, CaptionEditButtons, DeleteButton } from './styles';
import useLocalization from '../../../../../hooks/useLocalization';
import { TextareaAutosize } from 'brg-react-resize-textarea';
var CaptionEdit = function (_a) {
    var value = _a.value, onSubmit = _a.onSubmit, onCancel = _a.onCancel, isMultiLoad = _a.isMultiLoad, visible = _a.visible, deleteVisible = _a.deleteVisible, clear = _a.clear, _b = _a.maxLength, maxLength = _b === void 0 ? '200' : _b, variant = _a.variant;
    var ref = useRef();
    var _c = useState(value), text = _c[0], setText = _c[1];
    var _d = useState(false), collapse = _d[0], setCollapse = _d[1];
    var t = useLocalization().t;
    useEffect(function () {
        ref.current.focus();
    }, []);
    useEffect(function () {
        if (isMultiLoad && clear && ref) {
            ref.current.value = '';
            setText('');
        }
    }, [clear, isMultiLoad, ref]);
    useEffect(function () {
        if (collapse) {
            setTimeout(function () { return setCollapse(false); }, 500);
        }
    }, [collapse]);
    var handleChange = function (_a) {
        var value = _a.target.value;
        setText(value);
        if (isMultiLoad) {
            onSubmit && onSubmit(value);
        }
    };
    var handleSubmit = function () {
        onSubmit && onSubmit(text);
        setCollapse(true);
    };
    var onDelete = function () {
        setText('');
        onSubmit && onSubmit('');
        setCollapse(true);
    };
    var onCancelWithConfirmation = function () {
        if (!onCancel)
            return;
        // if (!window.confirm(t('confirmation.caption_delete'))) return
        onCancel(text);
    };
    if (isMultiLoad) {
        return (React.createElement(BottomCaption, { className: 'capt', isMultiLoad: true },
            React.createElement("input", { type: 'text', value: text, ref: ref, onChange: handleChange, placeholder: t('editor.add_caption_placeholder_multi'), maxLength: maxLength })));
    }
    return (React.createElement(BottomCaption, { className: 'capt', variant: variant },
        React.createElement(TextareaAutosize, { type: 'text', value: text, ref: ref, onFocus: function (e) {
                var _a;
                e.target.selectionStart = (_a = e.target.value) === null || _a === void 0 ? void 0 : _a.length;
            }, onChange: handleChange, placeholder: t('editor.add_caption_placeholder'), maxLength: maxLength, autoFocus: true, style: { resize: 'none', fontFamily: 'Inter' } }),
        React.createElement(CaptionEditButtons, null,
            React.createElement(AcceptButton, { onClick: handleSubmit }),
            !!deleteVisible && React.createElement(DeleteButton, { onClick: onDelete }),
            React.createElement(CancelButton, { onClick: onCancelWithConfirmation }))));
};
export default CaptionEdit;
//# sourceMappingURL=CaptionEdit.js.mapimport React, { useEffect, useRef, useState, useMemo } from 'react';
import { AcceptButton, BottomCaption, CancelButton, CaptionEditButtons, DeleteButton } from './styles';
import useLocalization from '../../../../../hooks/useLocalization';
import { TextareaAutosize } from 'brg-react-resize-textarea';
var CaptionEdit = function (_a) {
    var value = _a.value, onSubmit = _a.onSubmit, onCancel = _a.onCancel, isMultiLoad = _a.isMultiLoad, visible = _a.visible, deleteVisible = _a.deleteVisible, clear = _a.clear, _b = _a.maxLength, maxLength = _b === void 0 ? '200' : _b, variant = _a.variant;
    var ref = useRef();
    var _c = useState(value), text = _c[0], setText = _c[1];
    var _d = useState(false), collapse = _d[0], setCollapse = _d[1];
    var t = useLocalization().t;
    useEffect(function () {
        ref.current.focus();
    }, []);
    useEffect(function () {
        if (isMultiLoad && clear && ref) {
            ref.current.value = '';
            setText('');
        }
    }, [clear, isMultiLoad, ref]);
    useEffect(function () {
        if (collapse) {
            setTimeout(function () { return setCollapse(false); }, 500);
        }
    }, [collapse]);
    var handleChange = function (_a) {
        var value = _a.target.value;
        setText(value);
        if (isMultiLoad) {
            onSubmit && onSubmit(value);
        }
    };
    var handleSubmit = function () {
        onSubmit && onSubmit(text);
        setCollapse(true);
    };
    var onDelete = function () {
        setText('');
        onSubmit && onSubmit('');
        setCollapse(true);
    };
    var onCancelWithConfirmation = function () {
        if (!onCancel)
            return;
        // if (!window.confirm(t('confirmation.caption_delete'))) return
        onCancel(text);
    };
    if (isMultiLoad) {
        return (React.createElement(BottomCaption, { className: 'capt', isMultiLoad: true },
            React.createElement("input", { type: 'text', value: text, ref: ref, onChange: handleChange, placeholder: t('editor.add_caption_placeholder_multi'), maxLength: maxLength })));
    }
    return (React.createElement(BottomCaption, { className: 'capt', variant: variant },
        React.createElement(TextareaAutosize, { type: 'text', value: text, ref: ref, onFocus: function (e) {
                var _a;
                e.target.selectionStart = (_a = e.target.value) === null || _a === void 0 ? void 0 : _a.length;
            }, onChange: handleChange, placeholder: t('editor.add_caption_placeholder'), maxLength: maxLength, autoFocus: true, style: { resize: 'none', fontFamily: 'Inter' } }),
        React.createElement(CaptionEditButtons, null,
            React.createElement(AcceptButton, { onClick: handleSubmit }),
            !!deleteVisible && React.createElement(DeleteButton, { onClick: onDelete }),
            React.createElement(CancelButton, { onClick: onCancelWithConfirmation }))));
};
export default CaptionEdit;
//# sourceMappingURL=CaptionEdit.js.map